import { call, put, select, takeLatest } from 'redux-saga/effects';

import discountsService from 'services/discountsService';

import { getGroupId } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import {
  deleteDiscount,
  entities,
  formulaEdit,
  types,
  updateDiscount,
  updateVariable,
} from './actions';
import { getDiscount, getDiscountId } from './reducer';

export default function* root() {
  yield takeLatest(types.FORMULA_COMPILE_REQUEST, watchCompileFormula);
  yield takeLatest(types.DELETE_DISCOUNT_REQUEST, watchDeleteDiscount);
  yield takeLatest(types.UPDATE_DISCOUNT_REQUEST, watchUpdateDiscount);
  yield takeLatest(types.FORMULA_UPDATE_REQUEST, watchUpdateFormula);
  yield takeLatest(types.UPDATE_VARIABLE_REQUEST, watchUpdateVariable);
}

export function* initDiscountDetailsPage({ match }) {
  try {
    const discountId = match.params.discountId;
    const discount = yield call(discountsService.get, discountId);
    yield put(entities.receiveDiscount({ discount }));
  } catch (error) {
    console.error('ERROR WHEN INITIATING DISCOUNT DETAILS PAGE', error);
  }
}

function* watchCompileFormula(action) {
  const { formula } = action.payload;
  const supplierId = yield select(getGroupId);

  try {
    yield call(discountsService.compileFormula, {
      formula,
      supplierId,
    });
    yield put(formulaEdit.compileSuccess());
  } catch (error) {
    yield put(formulaEdit.compileError({ error: getErrorMessage(error) }));
  }
}

function* watchDeleteDiscount() {
  try {
    const discount = yield select(getDiscount);
    const discountId = discount.id;
    yield call(discountsService.delete, discountId);
    history.push('/processes/discounts');
    yield put(deleteDiscount.success());
  } catch (error) {
    yield put(deleteDiscount.error({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateDiscount(action) {
  try {
    const { discountId, data } = action.payload;
    const response = yield call(discountsService.update, discountId, data);
    yield put(updateDiscount.success({ discount: response }));
  } catch (error) {
    yield put(updateDiscount.error(error));
  }
}

function* watchUpdateFormula(action) {
  try {
    const { formula, revertedFrom } = action.payload;
    const discountId = yield select(getDiscountId);

    const nextFormula = yield call(
      discountsService.updateFormula,
      discountId,
      formula,
      revertedFrom,
    );
    const discount = yield call(discountsService.get, discountId);

    yield put(formulaEdit.updateSuccess({ formula: nextFormula }));
    yield put(entities.receiveDiscount({ discount }));
  } catch (error) {
    yield put(formulaEdit.updateError({ error: getErrorMessage(error) }));
  }
}

function* watchUpdateVariable(action) {
  try {
    const { data, variableId } = action.payload;
    const response = yield call(
      discountsService.updateVariable,
      variableId,
      data,
    );
    yield put(updateVariable.success({ variable: response }));
  } catch (error) {
    yield put(updateDiscount.error(error));
  }
}
